import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const OPERADORAS_CONST = 'operadoras';

export const allOperadorasService = async (params) => {
  const res = await axios.get(`${baseUrl}/${OPERADORAS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveOperadorasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${OPERADORAS_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${OPERADORAS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneOperadorasService = async (id) => {
  const res = await axios.get(`${baseUrl}/${OPERADORAS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteOperadorasService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${OPERADORAS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};
